import { useState, useCallback } from "react";

export type ContentLanguage = "de" | "en";

const STORAGE_KEY = "content_language";

function readLang(): ContentLanguage {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "en") return "en";
  } catch {
    // localStorage unavailable
  }
  return "de";
}

export function useContentLanguage(): [ContentLanguage, (lang: ContentLanguage) => void] {
  const [lang, setLangState] = useState<ContentLanguage>(readLang);

  const setLang = useCallback((next: ContentLanguage) => {
    setLangState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // localStorage unavailable
    }
  }, []);

  return [lang, setLang];
}
